module.exports = __webpack_public_path__ + "img/1540527986.08976692.jpg";